/* eslint-disable max-len */
import {SERVICE_NAMES} from '../constants';
import {createApiCall, fetchAllPages} from '../utils';
import type {
    ApiCallOptions,
    PaginatedResponse,
    RoleResource,
    AccountUserRoleResource,
    AccountUserPermissionResource,
    UserTokenPermissionResource,
    RoleAccountUsersResource,
    StoreRoleRequest,
    UpdateRoleRequest,
    SyncAccountUserRoleRequest,
    RoleListParams
} from './api.d';

export const permissionApi = {
    getRoles: (accountId: string, params?: RoleListParams, options?: ApiCallOptions) =>
        createApiCall<PaginatedResponse<RoleResource>>(SERVICE_NAMES.PERMISSION, 'GET', `accounts/${accountId}/roles`)({...options, params}),

    getRole: (accountId: string, roleId: string, options?: ApiCallOptions) =>
        createApiCall<RoleResource>(SERVICE_NAMES.PERMISSION, 'GET', `accounts/${accountId}/roles/${roleId}`)({...options}),

    createRole: (accountId: string, data: StoreRoleRequest, options?: ApiCallOptions) =>
        createApiCall<RoleResource>(SERVICE_NAMES.PERMISSION, 'POST', `accounts/${accountId}/roles`)({...options, data}),

    updateRole: (accountId: string, roleId: string, data: UpdateRoleRequest, options?: ApiCallOptions) =>
        createApiCall<RoleResource>(SERVICE_NAMES.PERMISSION, 'PUT', `accounts/${accountId}/roles/${roleId}`)({...options, data}),

    deleteRole: (accountId: string, roleId: string, options?: ApiCallOptions) =>
        createApiCall<void>(SERVICE_NAMES.PERMISSION, 'DELETE', `accounts/${accountId}/roles/${roleId}`)({...options}),

    getAllRoles: (accountId: string, params?: Omit<RoleListParams, 'page'>, options?: ApiCallOptions) =>
        fetchAllPages<RoleResource, {page?: number; per_page?: number; name?: string; description?: string}>(
            (paginationParams: {page?: number; per_page?: number; name?: string; description?: string}, opts?: ApiCallOptions) =>
                permissionApi.getRoles(accountId, paginationParams as unknown as RoleListParams, opts),
            params || {},
            options
        ),

    getRoleAccountUsers: (accountId: string, roleId: string, options?: ApiCallOptions) =>
        createApiCall<RoleAccountUsersResource>(SERVICE_NAMES.PERMISSION, 'GET', `accounts/${accountId}/roles/${roleId}/account-users`)({...options}),

    getAccountUserRoles: (accountUserId: string, options?: ApiCallOptions) =>
        createApiCall<AccountUserRoleResource>(SERVICE_NAMES.PERMISSION, 'GET', `account-users/${accountUserId}/roles`)({...options}),

    syncAccountUserRoles: (accountUserId: string, data: SyncAccountUserRoleRequest, options?: ApiCallOptions) =>
        createApiCall<AccountUserRoleResource>(SERVICE_NAMES.PERMISSION, 'POST', `account-users/${accountUserId}/roles`)({...options, data}),

    getAccountUserPermissions: (accountUserId: string, options?: ApiCallOptions) =>
        createApiCall<AccountUserPermissionResource>(SERVICE_NAMES.PERMISSION, 'GET', `account-users/${accountUserId}/permissions`)({...options}),

    getUserTokenPermissions: (userId: string, options?: ApiCallOptions) =>
        createApiCall<UserTokenPermissionResource>(SERVICE_NAMES.PERMISSION, 'GET', `users/${userId}/token-permissions`)({...options})
};
